import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import AssignJobModal from "./AssignJobModal";
import axios from "axios";
import { Select, MenuItem, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import LinearProgress from "@mui/material/LinearProgress";

import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import dayjs from "dayjs";
import CustomLinearProgress from "./CustomeLinearProgress";
import InhouseJobs from "./InhouseJobs";
import MyJobs from "./MyJobs";

const Jobs = () => {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
          ...(theme.palette.mode === "dark" && {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...(theme.palette.mode === "dark" && {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...(theme.palette.mode === "dark" && {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 13,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...(theme.palette.mode === "dark" && {
        backgroundColor: "#39393D",
      }),
    },
  }));
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
  const [openAssignModel, setopenAssignModel] = useState(false);
  const [openMoveModel, setopenMoveModel] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [selectedSubJobs, setSelectedSubJobs] = useState({});
  const [subJobs, setSubJobs] = useState(null);
  const [assignTaskSerial, setAssignTaskSerial] = useState(null);
  const [assignTaskSlNo, setAssignTaskSlNo] = useState(null);

  const [filteredLeadRows, setFilteredLeadRows] = useState([]); //client jobs
  const [filteredLeadRowsInHouse, setFilteredLeadRowsInHouse] = useState([]);
  const [filteredLeadRowsSelf, setFilteredLeadRowsSelf] = useState([]);
  const [shouldRefreshSubJobs, setShouldRefreshSubJobs] = useState(false);
  const [currentJobID, setCurrentJobID] = useState(null);
  const [accessGroup, setAccessGroup] = useState(null);
  const [openTaskStatusModel, setOpenTaskStatusModel] = useState(false);
  const [pendingTask, setPendingTask] = useState(null);
  const [completedTask, setCompletedTask] = useState(null);
  const [taskStageData, setTaskStageData] = useState(null);
  const [taskStageListFromAPI, setTaskStageListFromAPI] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [submitSnackbarMessage, setSubmitSnackbarMessage] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [disableAddTaskStageButton, setDisableAddTaskStageButton] =
    useState(false);
  const [subjobPresent, setSubjobPresent] = useState(false);
  // const [jobIdArray, setJobIdArray] = useState([]);
  // const [selectedJobsView, setSelectedJobsView] = useState("clientJobs");
  const location = useLocation();
  const { jobViewFromState } = location.state || {};
  // const [selectedJobsView, setSelectedJobsView] = useState(jobViewFromState || 'clientJobs');
  const [selectedJobsView, setSelectedJobsView] = useState("selfJobs");
  const [attachFileName, setAttachFileName] = useState("");
  const [attachFileEmpId, setAttachFileEmpId] = useState("");
  // const [disableAttachBtn, setDisableAttachBtn] = useState(true);
  const [disabledAttachMap, setDisabledAttachMap] = useState({});

  useEffect(() => {
    if (jobViewFromState) {
      setSelectedJobsView(jobViewFromState);
    }
  }, [jobViewFromState]);

  useEffect(() => {
    fetchTaskStageList();
    fetchJobList();
  }, []);

  useEffect(() => {
    fetchSubJobList(currentJobID);
  }, [shouldRefreshSubJobs, currentJobID]);

  const fetchJobList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const currentUserRaw = localStorage.getItem("currentUser");
    const currentUser = JSON.parse(currentUserRaw);
    // console.log("currentUser", currentUser);
    // console.log("Access Group:", currentUser[0]?.accessgrp);

    const accessgrp_From_Local = currentUser[0]?.accessgrp;

    let currentUserEmployeeIDRaw = currentUser[0]?.user;
    // let currentUserEmployeeID = JSON.parse(currentUserEmployeeIDRaw);
    let currentUserEmployeeID = currentUserEmployeeIDRaw;
    // console.log("currentUserEmployeeID", currentUserEmployeeID);

    let apiUrl = "";

    // if (accessgrp_From_Local === "CADMIN") {
    apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/ALL/-/${currentUserEmployeeID}/-/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("Job List :", data);
      // setFilteredLeadRows(data);
      const inHouseJobs = data.filter(
        (item, index) => item.Job_location === "In-house",
      );
      //  console.log('inHouseJobs:',inHouseJobs)
      // setFilteredLeadRowsSelf(selfJobs);
      setFilteredLeadRowsInHouse(inHouseJobs);
      const clientJobs = data.filter((item, index) => item.Job_location === "");
      //  console.log('clientJobs:',clientJobs)
      setFilteredLeadRows(clientJobs);

      // setJobIdArray()
      const JobIdArray = data?.map((item) => item.Job_id);
      // console.log("JobIdarray:", JobIdArray);
      // setJobIdArray(JobIdArray)
      // await fetchSubJobListCount(JobIdArray)
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };
  const fetchMyJobList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const currentUserRaw = localStorage.getItem("currentUser");
    const currentUser = JSON.parse(currentUserRaw);

    const USER = currentUser[0]?.user;

    let apiUrl = "";

    apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/ALL/${USER}/-/-/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("My Job List :", data);
      // setFilteredLeadRows(data);

      //  console.log('inHouseJobs:',inHouseJobs)
      setFilteredLeadRowsSelf(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };
  useEffect(() => {
    if (selectedJobsView === "selfJobs") {
      fetchMyJobList();
    } else {
      fetchJobList();
    }
  }, [selectedJobsView]);

  const fetchTaskStageList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // console.log('apiPaths_from_local_storage:',apiPaths_from_local_storage)

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterList/${company_code_from_local_storage}/TASKSTAGE/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      // console.log("Task Stage List :", data);
      setTaskStageListFromAPI(data);
    } catch (err) {
      console.error("Error while fetching task stage list", err);
    }
  };

  const fetchSubJobList = async (jobID) => {
    setSubJobs(null);
    // console.log("inside fetchSubJobList empid of :", jobID);
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let currentUserName = localStorage.getItem("currentUserName")
      ? localStorage.getItem("currentUserName")
      : "-";

    let currentUserEmployeeID = localStorage.getItem("currentUserEmployeeID");

    const currentUserRaw = localStorage.getItem("currentUser");
    const currentUser = JSON.parse(currentUserRaw);
    // console.log("currentUser", currentUser);
    // console.log("Access Group:", currentUser[0]?.accessgrp);

    const accessgrp_From_Local = currentUser[0]?.accessgrp;

    setAccessGroup(accessgrp_From_Local);

    let apiUrl = "";

    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/ASSIGNED/${empID}/-/-/MAIN/1900-01-01/1900-01-01/-/-/-`;

    apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/subjob/-/-/${jobID}/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      // console.log("SubJob List :", data);
      setSubJobs(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  //   const fetchSubJobListCount = async (jobIdArray) => {
  //   // setSubJobs(null);
  //   console.log("inside fetchSubJobList for job IDs:", jobIdArray);

  //   let company_code_from_local_storage = localStorage.getItem("companyCode") || "-";
  //   let apiPaths_from_local_storage = JSON.parse(localStorage.getItem("apiPaths")) || "-";
  //   let currentUserName = localStorage.getItem("currentUserName") || "-";
  //   let currentUserEmployeeID = localStorage.getItem("currentUserEmployeeID");

  //   const currentUserRaw = localStorage.getItem("currentUser");
  //   const currentUser = JSON.parse(currentUserRaw) || [];
  //   // console.log("currentUser:", currentUser);
  //   // console.log("Access Group:", currentUser[0]?.accessgrp);

  //   const accessgrp_From_Local = currentUser[0]?.accessgrp;
  //   setAccessGroup(accessgrp_From_Local);

  //   let subJobCount = 0;
  //   let allSubJobs = {};
  //   let hasSubJobs = false;

  //   try {
  //     const requests = jobIdArray.map((jobID) => {
  //       let apiUrl = "";
  //       if (accessgrp_From_Local === "ADMIN") {
  //         apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/subjob/-/-/${jobID}/MAIN/1900-01-01/1900-01-01/-/-/-`;
  //       } else {
  //         apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/subjob/${currentUserEmployeeID}/-/${jobID}/MAIN/1900-01-01/1900-01-01/-/-/-`;
  //       }
  //       return axios.get(apiUrl);
  //     });

  //     const responses = await Promise.all(requests);
  //     responses.forEach((response, index) => {
  //       const data = response.data;
  //       // console.log(`SubJob List Count:`, response.data);
  //       const jobID = jobIdArray[index];
  //       console.log(`SubJob List for Job ID ${jobID}:`, data);
  //       console.log(`subJobCount Data::`, data);
  //       // setSubjobPresent(data)
  //       subJobCount += data.length;
  //       allSubJobs[jobID] = data;
  //       console.log(`subJobCount::`, subJobCount);
  //       if(subJobCount>2){

  //        hasSubJobs = true;
  //       }
  //       allSubJobs[jobID] = data;
  //     });

  //     setSubJobs(subJobCount); // Or setSubJobs(allSubJobs) for detailed data
  //     console.log("Total SubJob Count:", subJobCount);
  //   setSubjobPresent(hasSubJobs)
  //   console.log("Total SubJob Count:", subJobCount);
  //     console.log("Sub-jobs present:", hasSubJobs);
  //   } catch (err) {
  //     console.error("Error while fetching sub-jobs:", err);
  //     setSubJobs(0);
  //     setSubjobPresent(false);
  //   }
  // };

  // useEffect(() => {
  //   if (selectedLeads.length > 2) {
  //     fetchSubJobListCount(selectedLeads);
  //   } else {
  //     setSubJobs(0);
  //     setSubjobPresent(false);
  //   }
  // }, [selectedLeads]);

  const statusMapping = {
    // newLead: "New Lead",
    newLead: "Unassigned",
    newJob: "New",
    // qualified: "Qualified",
    qualified: "Task Finished",
    pending: "Pending",
    assigned: "Assigned",
  };

  const navigate = useNavigate();

  const newJobForm = () => {
    navigate("/newJobForm");
  };

  const toggleSubJob = (leadId, subJobId) => {
    setSelectedSubJobs((prev) => {
      const current = prev[leadId] || [];
      return {
        ...prev,
        [leadId]: current.includes(subJobId)
          ? current.filter((id) => id !== subJobId)
          : [...current, subJobId],
      };
    });
  };

  // const removeSubJob = (leadId, subJobId) => {
  //   setFilteredLeadRows((prev) =>
  //     prev.map((row) =>
  //       row.lead_id === leadId
  //         ? {
  //             ...row,
  //             sub_jobs: row.sub_jobs.filter((sj) => sj.id !== subJobId),
  //           }
  //         : row
  //     )
  //   );
  // };

  const [moveJobId, setMoveJobId] = useState("");

  const openAssign = (slno) => {
    // setAssignTaskSerial(slno);
    setAssignTaskSlNo(slno);
    // console.log("open assign model clicked ");
    setopenAssignModel(true);
  };

  const openTaskStatusChange = (task) => {
    // console.log("open task status model clicked :", task);
    setOpenTaskStatusModel(true);
    setPendingTask(task);
    setCompletedTask(task);
  };

  const onMoveToCompleted = (jobID) => {
    setMoveJobId(jobID);
    setopenMoveModel(true);
  };

  const moveToCompletedJobs = async (e) => {
    e.preventDefault();
    // console.log("this job is moved to completed moveJobId", moveJobId);

    const jobToMove = filteredLeadRows?.find(
      (item) => item.Job_id === moveJobId,
    );

    const jobEntryTime = jobToMove?.Job_entryTime;
    const JobNotes = jobToMove?.Job_notes;

    // console.log("jobToMove:", jobToMove);

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment",
    );

    const currentUserName = localStorage.getItem("currentUserName");

    const jobCompletePayload = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "JOBSTATUS",
        DocNo: moveJobId,
        deptno: currentDepartmentFromLocalStorage,
        Status: "COMPLETED",
        Comments: JobNotes,
        // UserID: "ADMIN",
        UserID: currentUserName,
        created_on: jobEntryTime,
      },
    ];

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/ProposalStatus`;
    try {
      const response = await axios.post(apiUrl, jobCompletePayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response?.data;
      // console.log("This Job is moved to job completed Succesfully", data);
      setopenMoveModel(false);
      navigate("/jobs", { state: { defaultTab: "2" } });
    } catch (err) {
      console.error("Error while completing task", err);
    }
  };

  const closeMoveModal = (e) => {
    e.preventDefault();
    // console.log("this move modal is closed");
    setopenMoveModel(false);
  };

  const closeAssignModal = (e) => {
    e.preventDefault();
    // console.log("this assign modal is closed");
    setopenAssignModel(false);
  };

  const closeTaskStatusModal = (e) => {
    // e.preventDefault();
    // console.log("this move modal is closed");
    setOpenTaskStatusModel(false);
    setSelectedStage("");
    setSelectedCustomStage("");
    setSelectTaskChangeView(true);
    setCustomTaskChangeView(false);
  };

  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };

  const moveToPendingTasks = async (e) => {
    e.preventDefault();
    // console.log("this task is moved to pendingTask", pendingTask);

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment",
    );

    const currentUserName = localStorage.getItem("currentUserName");

    const taskPendingPayload = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "TASKSTATUS",
        DocNo: pendingTask.slno,
        deptno: currentDepartmentFromLocalStorage,
        Status: "PENDING",
        // Comments: pendingTask.task_instructions,
        Comments: selectedStage || selectedCustomStage,
        // UserID: user.EmpId,
        UserID: pendingTask.task_assignedto,
        created_on: pendingTask.task_scheduledatetime,
        target_on: pendingTask.task_targetdatetime,
      },
    ];

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/JobTaskStatus`;
    try {
      const response = await axios.post(apiUrl, taskPendingPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response?.data;
      // console.log("This task is moved to pending task Succesfully", data);
      // setopenMoveModel(false);
      // navigate("/jobs", { state: { defaultTab: "2" } });
      setShouldRefreshSubJobs((prev) => !prev);
      setOpenSubmitSnackbar(true);
      setSubmitSnackbarMessage("IN PROGRESS");
      await fetchJobList();
      setTimeout(() => {
        closeTaskStatusModal();
      }, 1000);
    } catch (err) {
      setOpenSnackbar(true);
      setSnackbarMessage("Task Status update failed!");
      console.error("Error while completing task", err);
    }
  };

  const moveToCompletedTasks = async (e) => {
    e.preventDefault();
    // console.log("this task is moved to completed", completedTask);

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment",
    );

    const currentUserName = localStorage.getItem("currentUserName");

    const taskCompletedPayload = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "TASKSTATUS",
        DocNo: completedTask.slno,
        deptno: currentDepartmentFromLocalStorage,
        Status: "COMPLETED",
        // Comments: completedTask.task_instructions,
        Comments: selectedStage || selectedCustomStage,
        // UserID: user.EmpId,
        UserID: completedTask.task_assignedto,
        created_on: completedTask.task_scheduledatetime,
        target_on: completedTask.task_targetdatetime,
      },
    ];

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/JobTaskStatus`;
    try {
      const response = await axios.post(apiUrl, taskCompletedPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response?.data;
      // console.log("This task is moved to completed task Succesfully", data);
      // setopenMoveModel(false);
      // navigate("/jobs", { state: { defaultTab: "2" } });
      setShouldRefreshSubJobs((prev) => !prev);
      setOpenSubmitSnackbar(true);
      setSubmitSnackbarMessage("Task Status updated to COMPLETED");
      await fetchJobList();

      setTimeout(() => {
        closeTaskStatusModal();
      }, 1000);
    } catch (err) {
      console.error("Error while completing task", err);
      setOpenSnackbar(true);
      setSnackbarMessage("Task Status update failed!");
    }
  };

  const [selectedStage, setSelectedStage] = useState("");
  const [selectedCustomStage, setSelectedCustomStage] = useState("");
  const [customTaskChangeView, setCustomTaskChangeView] = useState(false);
  const [selectTaskChangeView, setSelectTaskChangeView] = useState(true);

  const handleStageChange = (event) => {
    setSelectedStage(event.target.value);
  };

  const handleCustomStageChange = (event) => {
    setSelectedCustomStage(event.target.value);
  };

  const onAddTaskStageToMaster = async () => {
    // console.log("To add selectedCustomStage to master:", selectedCustomStage);

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterReg/ENTRY/${company_code_from_local_storage}/TASKSTAGE/${selectedCustomStage}/612157E4-0322-4C72-AADB-F9EED849697E`;

    try {
      const response = await axios.post(apiUrl);
      const data = response.data;
      // console.log("Data after adding to master:", data);
      setDisableAddTaskStageButton(true);
      setOpenSubmitSnackbar(true);
      setSubmitSnackbarMessage("Task Stage Added Successfully");
      await fetchTaskStageList();
    } catch (err) {
      console.error("Error while addding to master", err);
      setOpenSnackbar(true);
      setSnackbarMessage("Error while adding task stage!");
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    // setDuplicateItemCodeSnackbar(false);
  };

  useEffect(() => {
    setDisableAddTaskStageButton(false);
  }, [selectedCustomStage]);

  const handleChange = (event) => {
    setSelectedJobsView(event.target.value);
  };

  const handleFileAttachment = (e, empID) => {
    e.preventDefault();
    const file = e.target.files[0];
    const fileName = file?.name || "";
    // setAttachFileName(fileName);
    if (file) {
      setAttachFileName(file);
      setAttachFileEmpId(empID);
    }
    if (!empID) {
      alert("Assignee not found — disabling submit button.");
      return;
    }

    // ✅ Otherwise, set the button disabled state based on file presence
    setDisabledAttachMap((prev) => ({
      ...prev,
      [empID]: !file, // true if no file selected
      fileName: "",
    }));
  };

  const sendUserDoc = async () => {
    console.log("Submit attach btn clicked!");
    if (!attachFileName) {
      console.error("warning! No document selected");
      return;
    }

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    try {
      // Create a FormData instance
      const formData = new FormData();

      // let postEmpImagePath = localStorage.getItem("PostEmpImagePath");
      let postEmpImagePath = "C:\\fileupload_common\\";

      // Step 1: Clean up postEmpImagePath by removing extra quotes and trimming spaces
      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();

      // Step 2: Ensure it ends with a single backslash
      if (!basePath.endsWith("\\")) {
        basePath += "\\";
      }

      // Step 3: Append subfolder
      // const fullPath = `c:\\fileupload_common\\BONDTIME_EMP_IMG\\`;
      const fullPath = `${basePath}BONDTIME_DOC_IMG\\`;

      formData.append("DOC_CODE", attachFileEmpId);
      formData.append("DOC_TYPE", "DOCIMAGE");
      // Step 4: Add to formData
      formData.append("IMAGEPATH", fullPath);
      formData.append("IMGBASE64", "XX");
      formData.append("cmpcode", company_code_from_local_storage);
      formData.append("file", attachFileName);

      // Debug
      console.log("fullPath:", fullPath);

      // Axios configuration
      const config = {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure the correct content type
        },
      };

      // console.log("formData", formData);

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      // Send the POST request
      const response = await axios.post(
        `${apiPaths_from_local_storage[0].IMG_POST_PATH}/api/Image/upload`,
        formData,
        config,
      );

      // Handle response
      console.log("Response2:", response.data);

      if (response.status === 200) {
        setSubmitSnackbarMessage("File Uploaded Succesfully!");
        setOpenSubmitSnackbar(true);
        console.log("File upload Success");
        // fetchDocData(empState?.EmpId);
        setAttachFileName("");
        setAttachFileEmpId("");
        // setDisableAttachBtn(true);
      }
      // return response.data;
    } catch (error) {
      console.error("Error uploading file attachement data:", error);
      // showSnackbar("error", "Some error occurred");
    }
  };

  return (
    <div className="">
      <div className="flex justify-left items-center gap-4 mb-4">
        <h2 className="text-xl font-normal   mb-1">Tasks</h2>
        <button
          onClick={newJobForm}
          className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
        >
          Add Task
        </button>
        <FormControl>
          {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={selectedJobsView}
            onChange={handleChange}
          >
            <FormControlLabel
              value="selfJobs"
              control={
                <Radio
                  sx={{
                    color: "#BD1528",
                    "&.Mui-checked": {
                      color: "#BD1528",
                    },
                  }}
                />
              }
              label={`My Jobs (${filteredLeadRowsSelf?.length})`}
            />
            <FormControlLabel
              value="clientJobs"
              control={
                <Radio
                  sx={{
                    color: "#BD1528",
                    "&.Mui-checked": {
                      color: "#BD1528",
                    },
                  }}
                />
              }
              label={`Client Tasks (${filteredLeadRows?.length})`}
            />
            <FormControlLabel
              value="inhouseJobs"
              control={
                <Radio
                  sx={{
                    color: "#BD1528",
                    "&.Mui-checked": {
                      color: "#BD1528",
                    },
                  }}
                />
              }
              label={`In-house Tasks (${filteredLeadRowsInHouse?.length})`}
            />
          </RadioGroup>
        </FormControl>
      </div>
      {selectedLeads.length > 0 && (
        <button
          className="bg-red-500 text-white text-xl px-1 pb-1 mb-2 rounded"
          onClick={() =>
            setFilteredLeadRows((prev) =>
              prev.filter((row) => !selectedLeads.includes(row.lead_id)),
            )
          }
        >
          <AiFillDelete className="inline-block " />
          {/* Delete Selected */}
        </button>
      )}
      {selectedJobsView === "clientJobs" ? (
        <div className="overflow-auto max-h-[60vh] border">
          <table className="min-w-full table-auto border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th></th>
                <th className="shadow-sm px-1 py-0.5 text-center">
                  <div className="flex justify-center gap-2 items-center">
                    <input
                      type="checkbox"
                      className="rounded border border-sm shadow"
                      onChange={(e) =>
                        setSelectedLeads(
                          e.target.checked
                            ? filteredLeadRows.map((row) => row.lead_id)
                            : [],
                        )
                      }
                      checked={
                        selectedLeads.length > 0 &&
                        selectedLeads.length === filteredLeadRows.length
                      }
                    />
                    <div className="bg-transparent w-4 h-4"></div>
                  </div>
                </th>
                <th className="border pl-1 text-left font-normal">Task ID</th>
                <th className="border pl-1 text-left font-normal text-center">
                  Date
                </th>
                <th className="border pl-1 text-left font-normal">Customer</th>
                <th className="border pl-1 text-left font-normal">Creator</th>
                <th className="border pl-1 text-left font-normal">
                  Create Date
                </th>
                <th className="border pl-1 text-left font-normal">
                  Contact Person
                </th>
                <th className="border pl-1 text-left font-normal">
                  Contact Phone
                </th>
                {/* <th className="border pl-1 text-left font-normal">Title</th> */}
                <th className="border pl-1 text-left font-normal">Email</th>
                {/* <th className="border pl-1 text-left font-normal">Notes</th> */}
                <th className="border pl-1 text-left font-normal">
                  Task Description
                </th>
                <th className="border pl-1 text-left font-normal">Progress</th>
                <th className="border pl-1 text-left font-normal">
                  Task Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {/* {filteredLeadRowsInHouse.map((row) => ( */}
              {filteredLeadRows.map((row) => (
                <React.Fragment key={row.Job_id}>
                  <tr
                    key={row.Job_id}
                    className={
                      selectedLeads.includes(row.Job_id) ? "bg-blue-100" : ""
                    }
                  >
                    <td className="border px-2 text-center">
                      <button
                        onClick={() => {
                          setCurrentJobID(row.Job_id);
                          fetchSubJobList(row.Job_id);
                          setOpenRow(
                            openRow === row.Job_id ? null : row.Job_id,
                          );
                        }}
                        className="text-gray-600 hover:text-black"
                      >
                        {openRow === row.Job_id ? (
                          <IoIosArrowUp size={18} />
                        ) : (
                          <IoIosArrowDown size={18} />
                        )}
                      </button>
                    </td>
                    <td className="border px-3 py-2 text-center">
                      <div className="flex justify-center gap-2 items-center">
                        <input
                          type="checkbox"
                          checked={selectedLeads.includes(row.Job_id)}
                          className="rounded border border-sm shadow"
                          onChange={() =>
                            setSelectedLeads((prev) =>
                              prev.includes(row.Job_id)
                                ? prev.filter((id) => id !== row.Job_id)
                                : [...prev, row.Job_id],
                            )
                          }
                        />
                        {row?.Cnt > 0 ? (
                          <div className="rounded-full bg-gray-300 w-4 h-4 text-black font-semibold text-[0.6rem] flex justify-center items-center">
                            <span className="">{row?.Cnt}</span>
                          </div>
                        ) : (
                          <div className="rounded-full bg-transparent w-4 h-4 text-white text-[0.4rem] flex justify-center items-center">
                            <span className="">{"0000"}</span>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="border px-3 py-2">{row.Job_id}</td>
                    {/* <td className="border px-3 py-2">{row.lead_date}</td> */}
                    <td className="border px-3 py-2 text-center">
                      {/* {dayjs(row.Job_entryTime).format("DD-MMM-YYYY hh:mm A")}{" "} */}
                      {dayjs(row.Job_entryTime).format("DD-MMM-YYYY ")}{" "}
                      <div className="text-xs font-thin bg-gray-400 px-0.5 text-center rounded-lg text-white">
                        {calculateAgedDays(row.Job_entryTime)}
                      </div>
                    </td>
                    <td className="border px-3 py-2">{row.Job_organization}</td>
                    <td className="border px-3 py-2">{row.Job_salesperson}</td>
                    <td className="border px-3 py-2">
                      {dayjs(row.Job_entryTime).format("DD-MMM-YYYY ")}{" "}
                    </td>
                    <td className="border px-3 py-2">
                      {row.Job_primarycontact}
                    </td>
                    <td className="border px-3 py-2">{row.Job_phone}</td>
                    {/* <td className="border px-3 py-2">
                  {row.lead_primarycontacttitle}
                </td> */}
                    <td className="border px-3 py-2">{row.Job_email}</td>
                    <td className="border px-3 py-2">{row.Job_notes}</td>
                    {/* <td className="border px-3 py-2">{row.lead_probability}</td> */}
                    {/* <td className="border px-3 py-2">
                  <ProgressBar now={60} label={`${60}%`} />
                  </td> */}
                    <td className="border px-3 py-2 ">
                      <div className="flex items-center justify-center">
                        <CustomLinearProgress value={row?.Perc} />
                      </div>
                    </td>
                    <td className="border px-3 py-2 text-center">
                      {row?.Perc === 100 ? (
                        <button
                          onClick={
                            accessGroup === "ADMIN"
                              ? () => onMoveToCompleted(row.Job_id)
                              : undefined
                          }
                          className={`px-2 py-1 rounded text-white text-sm bg-green-500`}
                        >
                          Task Completed
                        </button>
                      ) : (
                        <button
                          // onClick={
                          //   row.Job_status === "JOB COMPLETED"
                          //   ? () => onMoveToCompleted(row.Job_id)
                          //   : undefinedg
                          // }
                          className={`px-2 py-1 rounded text-white text-sm ${
                            row.Job_status === "newJob"
                              ? "bg-blue-500"
                              : row.Job_status === "Task COMPLETED"
                                ? "bg-green-500"
                                : row.Job_status === "pending"
                                  ? "bg-orange-500"
                                  : row.Job_status === "assigned"
                                    ? "bg-blue-500"
                                    : "bg-gray-400"
                          }`}
                        >
                          {/* completed for approval  */}
                          {statusMapping[row.Job_status] || row.Job_status}
                        </button>
                      )}
                    </td>
                  </tr>

                  {/* Collapsible Row */}
                  <AnimatePresence>
                    {openRow === row.Job_id && (
                      <tr>
                        <td colSpan={13} className="p-0 border-t">
                          <motion.div
                            key={`details-${row.Job_id}`}
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3, ease: "easeInOut" }}
                            className="overflow-hidden bg-gray-50 px-4 py-2 text-sm text-gray-700"
                          >
                            <div className="text-sm text-gray-700">
                              {/* <p className="mb-2 font-semibold">Sub-Jobs:</p> */}
                              <p className="mb-2 font-semibold">Tasks:</p>
                              {/* {row.sub_jobs && row.sub_jobs.length > 0 ? ( */}
                              {subJobs && subJobs?.length > 0 ? (
                                <ul className="space-y-2">
                                  {/* {row.sub_jobs.map((subJob) => ( */}
                                  {subJobs?.map((subJob) => (
                                    <li
                                      // key={subJob.id}
                                      key={subJob.Job_id}
                                      className="flex justify-between items-center bg-white border rounded px-3 py-2 shadow-sm "
                                    >
                                      {/* <label className="flex items-center gap-2 cursor-pointer bg-blue-200"> */}
                                      {/* <input
                                        type="checkbox"
                                        checked={
                                          selectedSubJobs[row.Job_id]?.includes(
                                            subJob.id
                                          ) || false
                                        }
                                        onChange={() =>
                                          toggleSubJob(row.Job_id, subJob.id)
                                        }
                                        //   className="accent-green-600"
                                        className="rounded border border-sm shadow accent-green-600"
                                      /> */}

                                      {/* <div className="flex flex-col justify-center items-center bg-red-100">
                                        <strong className="text-[0.7rem]">Sl No: </strong>{" "}
                                        <strong className="">{subJob.task_serial || "—"}</strong>{" "}
                                        
                                      </div> */}

                                      {/* <span>  {subJob.task_serial || "—"}</span> */}
                                      {/* </label> */}
                                      {/* Remove */}
                                      {/* <button
            onClick={() => removeSubJob(row.lead_id, subJob.id)}
            className="text-red-500 text-sm hover:underline"
            >
            <AiFillDelete className="inline-block mr-1 text-xl p-0.5  rounded bg-red-500 text-white" />
            
            </button>*/}
                                      <div className="flex flex-col justify-left max-w-[400px]">
                                        <div className="flex justify-between items-center  ">
                                          <span className="flex flex-col justify-left">
                                            <strong>Sl No: </strong>{" "}
                                            {subJob.task_serial || "—"}
                                          </span>
                                          <span className="flex flex-col justify-left ml-4">
                                            <strong> Task Group: </strong>{" "}
                                            {subJob.task_Group || "—"}
                                          </span>
                                        </div>
                                        <br />
                                        <span className="flex flex-col justify-left">
                                          <strong>
                                            Task Created Date Time:{" "}
                                          </strong>{" "}
                                          {/* {subJob.Job_entryTime || "—"} */}
                                          {dayjs(subJob.Job_entryTime).format(
                                            "DD-MMM-YYYY hh:mm A",
                                          )}
                                          {""}
                                        </span>
                                      </div>
                                      <br />
                                      <div className="flex flex-col justify-left ">
                                        <span className="flex flex-col justify-left">
                                          <strong> Task Description: </strong>{" "}
                                          {subJob.task_description || "—"}
                                        </span>
                                        <br />
                                        <span className="flex flex-col justify-left text-green-600">
                                          <strong className="text-black">
                                            {" "}
                                            Scheduled Date Time:{" "}
                                          </strong>{" "}
                                          {dayjs(
                                            subJob.task_scheduledatetime,
                                          ).format("DD-MMM-YYYY hh:mm A")}
                                          {""}
                                        </span>
                                      </div>
                                      <div className="flex flex-col justify-left ">
                                        <span className="flex flex-col justify-left">
                                          <strong>Assignee:</strong>{" "}
                                          {subJob.task_assignedto || "—"}
                                        </span>
                                        <br />
                                        <span className="flex flex-col justify-left mt-2 text-red-600">
                                          <strong className="text-black">
                                            Task Target Date:
                                          </strong>{" "}
                                          {/* {subJob.task_targetdatetime || "—"} */}
                                          {dayjs(
                                            subJob.task_targetdatetime,
                                          ).format("DD-MMM-YYYY hh:mm A")}
                                          {""}
                                        </span>
                                      </div>
                                      <br />
                                      <div className="flex flex-col justify-left ">
                                        <span className="flex flex-col justify-left">
                                          <strong>Instruction:</strong>{" "}
                                          {subJob.task_instructions || "—"}
                                        </span>
                                        <span className="flex flex-col justify-left mt-2">
                                          <strong>Comments:</strong>{" "}
                                          {subJob.task_comments || "—"}
                                        </span>
                                      </div>
                                      <br />
                                      <div className="flex flex-col justify-left">
                                        <span className="flex flex-col justify-left">
                                          <strong>Assigned Time:</strong>{" "}
                                          {/* {subJob.task_scheduledatetime || "—"} */}
                                          {dayjs(
                                            subJob.task_scheduledatetime,
                                          ).format("DD-MMM-YYYY hh:mm A")}
                                          {""}
                                        </span>
                                        <br />
                                        <span>
                                          <strong>Attachments:</strong>
                                        </span>
                                        {/* <ul className="list-disc list-inside text-sm">
                                        {subJob.attachments &&
                                        subJob.attachments.length > 0 ? (
                                          subJob.attachments.map(
                                            (file, idx) => (
                                              <li key={idx}>
                                                <a
                                                  href={file.url}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-blue-600 hover:underline"
                                                >
                                                  {file.fileName}
                                                </a>{" "}
                                                {/* <span className="text-gray-500 text-xs">
                                              ({file.uploadedAt})
                                            </span> 
                                              </li>
                                            )
                                          )
                                        ) : (
                                          <li className="text-gray-500">
                                            No attachments
                                          </li>
                                        )}
                                      </ul> */}

                                        <div className="flex flex-col  justify-left  items-center">
                                          <input
                                            type="file"
                                            multiple
                                            onChange={(e) =>
                                              handleFileAttachment(
                                                e,
                                                subJob.task_assignedto,
                                              )
                                            }
                                            className="mt-1 block w-full text-sm text-gray-700
               file:mr-4 file:py-0.5 file:px-1
               file:rounded file:border-0
               file:text-sm file:font-semibold
               file:bg-blue-50 file:text-blue-700
               hover:file:bg-blue-100"
                                          />
                                          {(() => {
                                            const isDisabled =
                                              disabledAttachMap[
                                                subJob.task_assignedto
                                              ] ?? true;

                                            return (
                                              <button
                                                disabled={isDisabled}
                                                type="button"
                                                onClick={sendUserDoc}
                                                className={`inline-flex mt-2 justify-left items-center px-1 py-0.5 text-xs font-normal rounded-md text-sm font-medium shadow-sm transition
            ${
              isDisabled
                ? "bg-gray-400 text-white cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700 text-white"
            }
          `}
                                              >
                                                Submit Document
                                              </button>
                                            );
                                          })()}
                                        </div>
                                      </div>

                                      {accessGroup === "ADMIN" ? (
                                        // <button
                                        //   onClick={() =>
                                        //     // openAssign(subJob.task_serial)
                                        //     openAssign(subJob.slno)
                                        //   }
                                        //   className={`px-2 py-1 rounded text-sm font-medium ${
                                        //     subJob.task_status === "ASSIGNED"
                                        //       ? "bg-blue-500 hover:bg-blue-600 text-white"
                                        //       : "bg-gray-400 hover:bg-gray-500 text-white"
                                        //   }`}
                                        // >
                                        //   {subJob.task_status === "ASSIGNED"
                                        //     ? "Assigned"
                                        //     : "Unassigned"}
                                        // </button>
                                        <button
                                          onClick={() =>
                                            // openAssign(subJob.task_serial)
                                            openAssign(subJob.slno)
                                          }
                                          className={`px-2 py-1 rounded text-sm font-medium ${
                                            subJob.task_status === "ASSIGNED"
                                              ? "bg-blue-500 hover:bg-blue-600 text-white"
                                              : subJob.task_status === "PENDING"
                                                ? "bg-yellow-500 hover:bg-yellow-600 text-white"
                                                : subJob.task_status ===
                                                    "COMPLETED"
                                                  ? "bg-green-500 hover:bg-green-600 text-white"
                                                  : "bg-gray-400 hover:bg-gray-500 text-white"
                                          }`}
                                        >
                                          {subJob.task_status === "ASSIGNED"
                                            ? "Assigned"
                                            : subJob.task_status === "PENDING"
                                              ? "In Progress"
                                              : subJob.task_status ===
                                                  "COMPLETED"
                                                ? "Completed"
                                                : "Unassigned"}
                                        </button>
                                      ) : (
                                        // <button
                                        //   onClick={() =>
                                        //     // openAssign(subJob.task_serial)
                                        //     // openAssign(subJob.slno)
                                        //   }
                                        //   className={`px-2 py-1 rounded text-sm font-medium ${
                                        //     subJob.task_status === "ASSIGNED"
                                        //       ? "bg-blue-500 hover:bg-blue-600 text-white"
                                        //       : "bg-gray-400 hover:bg-gray-500 text-white"
                                        //   }`}
                                        // >
                                        //   {subJob.task_status === "ASSIGNED"
                                        //     ? "Assigned"
                                        //     : "Unassigned"}
                                        // </button>

                                        <button
                                          onClick={() =>
                                            openTaskStatusChange(subJob)
                                          }
                                          className={`px-2 py-1 rounded text-sm font-medium ${
                                            subJob.task_status === "ASSIGNED"
                                              ? "bg-blue-500 hover:bg-blue-600 text-white"
                                              : subJob.task_status === "PENDING"
                                                ? "bg-yellow-500 hover:bg-yellow-600 text-white"
                                                : subJob.task_status ===
                                                    "COMPLETED"
                                                  ? "bg-green-500 hover:bg-green-600 text-white"
                                                  : "bg-gray-400 hover:bg-gray-500 text-white"
                                          }`}
                                        >
                                          {subJob.task_status === "ASSIGNED"
                                            ? "Assigned"
                                            : subJob.task_status === "PENDING"
                                              ? "In Progress"
                                              : subJob.task_status ===
                                                  "COMPLETED"
                                                ? "Completed"
                                                : "Unassigned"}
                                        </button>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="text-gray-400 italic">
                                  No tasks found.
                                </p>
                              )}
                            </div>
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>
                </React.Fragment>
              ))}
            </tbody>
          </table>

          {openAssignModel && (
            <div className="fixed bg-black bg-opacity-50 inset-0 flex justify-center items-center z-50">
              <div className="relative w-full  max-w-3xl bg-transparent rounded-xl   p-1 ">
                <AssignJobModal
                  // onAssign={handleAssignPerson}

                  onClose={() => setopenAssignModel(false)}
                  taskSerial={assignTaskSlNo}
                  setShouldRefreshSubJobs={setShouldRefreshSubJobs}
                  shouldRefreshSubJobs={shouldRefreshSubJobs}
                />
              </div>
            </div>
          )}
          {openMoveModel && (
            <div className="fixed bg-black bg-opacity-50 inset-0 flex justify-center items-center z-50">
              <div className="relative w-full max-w-lg bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-6 max-h-[50vh]">
                {/* Sticky Close Button */}
                <h2 className="font-semibold ml-6 text-center text-xl">
                  Are you sure to move this task to completed?
                </h2>
                <div className="flex justify-center items-center pt-4 gap-8">
                  <button
                    className="text-lg text-white bg-blue-500 px-3 py-1 rounded "
                    onClick={(e) => moveToCompletedJobs(e)}
                  >
                    Move
                  </button>
                  <button
                    className="text-lg text-white bg-gray-500 px-2 py-1 rounded"
                    onClick={(e) => closeMoveModal(e)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {openTaskStatusModel && (
            <div className="fixed bg-black bg-opacity-50 inset-0 flex justify-center items-center z-50">
              <div className="relative w-full max-w-2xl bg-white rounded-2xl p-6 max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold text-gray-900">
                    Update Task Status
                  </h2>
                  <button
                    className="text-3xl text-gray-600 hover:text-red-500 transition-colors"
                    onClick={closeTaskStatusModal}
                    title="Close"
                  >
                    &times;
                  </button>
                </div>

                {/* Content */}
                <div className="flex flex-col gap-6">
                  {/* Add New Task Stage */}
                  <div className="flex flex-col gap-4">
                    {/* <h3 className="text-lg font-medium text-gray-800">
                    Add New Task Stage
                  </h3> */}

                    {/* Task Stage Selection */}
                    <div className="flex flex-col gap-4">
                      {selectTaskChangeView && (
                        <FormControl fullWidth variant="standard">
                          <FormLabel
                            component="legend"
                            className="text-lg font-medium text-gray-800 mb-2"
                          >
                            Select Task Stage
                          </FormLabel>
                          <Select
                            value={selectedStage}
                            onChange={handleStageChange}
                            displayEmpty
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  maxHeight: 400, // limits visible height
                                  "& .MuiMenuItem-root": {
                                    minHeight: "32px", // decrease individual item height
                                    // fontSize: "0.875rem", // optional: smaller font
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value="" disabled>
                              -- Select a Task stage --
                            </MenuItem>
                            {taskStageListFromAPI?.map((item) => (
                              <MenuItem
                                key={item.TranId}
                                value={item.Description}
                              >
                                {item.Description}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {/* <button
                      onClick={()=>{
                        setCustomTaskChangeView(true)  
                        setSelectedStage('')
                      }}
                      // disabled={!selectedStage}
                      className={`rounded px-4 py-2 w-[220px] bg-[#A01FF0] hover:bg-purple-700 text-white }`}
                    >
                      Custom Task Stage
                    </button> */}
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            checked={customTaskChangeView}
                            className="mr-4"
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setCustomTaskChangeView(checked);
                              setSelectTaskChangeView(!checked);

                              if (checked) {
                                setSelectedStage("");
                              }
                            }}
                          />
                        }
                        label="Custom Task Stage"
                      />
                    </div>
                    {customTaskChangeView && (
                      <div className="flex justify-between items-center gap-4 items-center">
                        <TextField
                          label="Task Stage"
                          // value={taskStageData}
                          value={selectedCustomStage}
                          // onChange={(e) => setTaskStageData(e.target.value)}
                          onChange={(e) =>
                            setSelectedCustomStage(e.target.value)
                          }
                          placeholder="Enter Custom Task Stage"
                          variant="standard"
                          size="small"
                          fullWidth
                          error={taskStageData === ""}
                          helperText={
                            taskStageData === ""
                              ? "Enter Custom Task Stage"
                              : ""
                          }
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                            "& .MuiInputLabel-root": {
                              fontFamily: "Figtree, sans-serif", // Force Figtree font for label
                            },
                            "& .MuiInputBase-input:focus": {
                              boxShadow: "none !important", // Removes any shadow applied
                            },
                          }}
                        />

                        <button
                          onClick={onAddTaskStageToMaster}
                          disabled={
                            !selectedCustomStage || disableAddTaskStageButton
                          }
                          className={`rounded px-4 py-2 w-[220px] ${
                            !selectedCustomStage || disableAddTaskStageButton
                              ? "bg-blue-300 text-white cursor-not-allowed"
                              : "bg-blue-500 hover:bg-blue-700 text-white"
                          }`}
                        >
                          {/* Add New Task Stage */}
                          Add To Master (optional)
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="flex justify-end gap-4 mt-6">
                    <button
                      // onClick={() => handleUpdateStatus("Pending")}
                      onClick={(e) => moveToPendingTasks(e)}
                      className={`px-4 py-2 rounded-lg  w-[220px]  transition ${
                        selectedStage || selectedCustomStage
                          ? "bg-yellow-500 text-white hover:bg-yellow-600"
                          : "bg-yellow-300 text-white cursor-not-allowed"
                      }`}
                      disabled={!selectedStage && !selectedCustomStage}
                    >
                      In Progress
                    </button>

                    <button
                      onClick={(e) => moveToCompletedTasks(e)}
                      // onClick={() => handleUpdateStatus("Completed")}
                      className={`px-4 py-2 rounded-lg  w-[220px]  transition ${
                        selectedStage || selectedCustomStage
                          ? "bg-green-600 text-white hover:bg-green-700"
                          : "bg-green-300 text-white cursor-not-allowed"
                      }`}
                      disabled={!selectedStage && !selectedCustomStage}
                    >
                      Completed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : selectedJobsView === "inhouseJobs" ? (
        <div className="mt-2">
          <InhouseJobs
            filteredLeadRowsInHouse={filteredLeadRowsInHouse}
            selectedLeads={selectedLeads}
            setSelectedLeads={setSelectedLeads}
            fetchSubJobList={fetchSubJobList}
            // moveToCompletedTasks={moveToCompletedTasks}
            openRow={openRow}
            setOpenRow={setOpenRow}
            calculateAgedDays={calculateAgedDays}
            onMoveToCompleted={onMoveToCompleted}
            statusMapping={statusMapping}
            subJobs={subJobs}
            accessGroup={accessGroup}
            openAssign={openAssign}
            onAddTaskStageToMaster={onAddTaskStageToMaster}
            closeTaskStatusModal={closeTaskStatusModal}
            moveToPendingTasks={moveToPendingTasks}
            moveToCompletedJobs={moveToCompletedJobs}
            handleStageChange={handleStageChange}
            closeMoveModal={closeMoveModal}
          />
        </div>
      ) : selectedJobsView === "selfJobs" ? (
        <div className="mt-10">
          <MyJobs
            filteredLeadRowsInHouse={filteredLeadRowsSelf}
            selectedLeads={selectedLeads}
            setSelectedLeads={setSelectedLeads}
            fetchSubJobList={fetchSubJobList}
            // moveToCompletedTasks={moveToCompletedTasks}
            openRow={openRow}
            setOpenRow={setOpenRow}
            calculateAgedDays={calculateAgedDays}
            onMoveToCompleted={onMoveToCompleted}
            statusMapping={statusMapping}
            subJobs={subJobs}
            accessGroup={accessGroup}
            openAssign={openAssign}
            onAddTaskStageToMaster={onAddTaskStageToMaster}
            closeTaskStatusModal={closeTaskStatusModal}
            moveToPendingTasks={moveToPendingTasks}
            moveToCompletedJobs={moveToCompletedJobs}
            handleStageChange={handleStageChange}
            closeMoveModal={closeMoveModal}
          />
        </div>
      ) : (
        ""
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          {/* Error while adding task stage! */}
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          {/* Task Stage Added Successfully! */}
          {submitSnackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* <ProgressBar now={60} label={`${60}%`} /> */}
      {/* <LinearProgress variant="determinate" value={60} /> */}
    </div>
  );
};

export default Jobs;
